/**
 * Meesterschap-scène (§1.2): na het verslaan van de eindbaas wordt de
 * meesterschapskaart van dit chakra ontgrendeld — ze reist mee naar alle
 * volgende chakra's.
 */
import type { Origin } from '../data/types';
import { HEADERS } from '../data/headers';
import { meesterschapskaart } from '../data/chakras';
import { KaartView } from './KaartView';
import { ChakraAchtergrond } from './art/ChakraAchtergrond';
import { t, type Taal } from '../i18n';

interface Props {
  chakra: Origin;
  taal: Taal;
  onKlaar: () => void;
}

export function MeesterschapScene({ chakra, taal, onKlaar }: Props) {
  const header = HEADERS[chakra];
  const kaart = meesterschapskaart(chakra);

  return (
    <ChakraAchtergrond chakra={chakra}>
    <div className="flex h-full w-full flex-col items-center justify-center gap-6 p-6 text-slate-100">
      <div className="text-center">
        <div className="text-2xl font-bold" style={{ fontFamily: 'Cinzel, serif', color: header.accent }}>{t('ui.chakraVoltooid', taal)}</div>
        <div className="mt-1 text-sm text-slate-400">{header.naam} · {header.resourceLabel}</div>
      </div>

      {kaart && (
        <div className="flex flex-col items-center gap-2">
          <div className="text-xs uppercase tracking-widest text-slate-500">{t('ui.meesterschap', taal)}</div>
          <div className="scale-125 py-4">
            <KaartView
              inst={{ instId: kaart.id, kaart }}
              kleur={header.kleur}
              accent={header.accent}
              taal={taal}
              bevroren={false}
              speelbaar={false}
              reden={null}
              onSpeel={() => {}}
            />
          </div>
        </div>
      )}

      <button type="button" onClick={onKlaar} className="rounded-lg px-6 py-2 font-semibold text-black transition hover:brightness-110" style={{ background: header.accent }}>
        {t('vn.verder', taal)} →
      </button>
    </div>
    </ChakraAchtergrond>
  );
}
